import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import Style from './style.js';
import { jsx } from '@emotion/react';

var _excluded = ["children", "onClick"];
var AnchorLinkButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    children,
    onClick
  } = props,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx("button", _extends({}, rest, {
    ref: ref,
    css: Style.anchorLinkButton,
    onClick: onClick,
    type: "button"
  }), children);
});

export { AnchorLinkButton };
